const get = (target = {}, path = '', defaultValue = undefined): any => {
    const result = path
        .replace(/\[(\d+)\]/g, (x) => `.${x[1]}`) // replace [2] with .2
        .split('.')
        .map((key) => (Number.isNaN(Number.parseFloat(key)) ? key : parseInt(key, 10)))
        .reduce((obj, key) => {
            if (!obj || !Object.prototype.hasOwnProperty.call(obj, key)) {
                return undefined;
            }

            return obj[key];
        }, target);

    return result === undefined ? defaultValue : result;
};

export default get;
